module.exports = __webpack_public_path__ + "media/images/badges/yogasix/february-badge-1afd717f5841ec6a00c3b9af9e2343c2.png";